<template>
   <div>
      <!-- 生徒写真が存在していない場合アイコン表示 -->
      <v-avatar v-if="this.photoExistsFlg == false" color="grey lighten-5">
         <v-img
            src="@/assets/student.png"
            max-width="100"
            max-height="100"
         >
         </v-img>
      </v-avatar>
      <!-- 写真読込中 or 生徒写真が存在している場合 写真表示 -->
      <v-avatar v-if="this.photoExistsFlg == true" color="grey lighten-5">
         <v-img
            :src="photoPath"
            lazy-src="@/assets/student.png"
            max-width="100"
            max-height="100"
            @click="zoomView"
            style="cursor:zoom-in"
         >
            <template v-slot:placeholder>
               <!-- 写真読込中のクルクル表示 -->
               <v-row
                  v-if="loadingFlg == true"
                  class="fill-height ma-0"
                  align="center"
                  justify="center"
               >
                  <v-progress-circular
                     indeterminate
                     color="grey lighten-5"
                  />
               </v-row>
            </template>
         </v-img>
      </v-avatar>
      <v-dialog
         v-model="zoomViewDialog"
         scrollable
         max-width="200"
         max-height="200"
         @click="closeZoom"
      >
         <v-img
            :src="photoPath"
            @click="closeZoom"
            max-width="200"
            max-height="200"
            style="cursor:pointer"
            contain
         />
      </v-dialog>
   </div>
</template>

<script>
import { httpsCallable, getFunctions } from "firebase/functions";
export default {
   props: ['studentId'],
   // 初期表示時データ読み込み
   async created() {
      console.log("StudentAvatar", this.studentId);

      const functions = getFunctions(this.$firebase);
      functions.region = "asia-northeast1";
      const schoolAidHomeLogined = httpsCallable(functions,"schoolAidHomeLogined");
      const data = {
        funcName: "loadStudentAvatar",
        studentId: this.studentId
      };
      await schoolAidHomeLogined(data).then((res) => {
         this.loadingFlg = false;
         this.photoExistsFlg = res.data.photoExistsFlg;
         this.photoPath = res.data.photoPath;
      });
   },
   data() {
      return {
         // 読込中
         loadingFlg: true,
         // 生徒写真存在確認
         photoExistsFlg: true,
         // 写真ファイルパス
         photoPath: "",
         // 顔写真のズーム表示
         zoomViewDialog: false,
      };
   },
   methods: {
    // 原寸画像ダイアログを表示
    zoomView(){
      if(this.loadingFlg == false && this.photoExistsFlg == true) {
        this.zoomViewDialog = true;
      }
    },
    // 原寸画像ダイアログを閉じる
    closeZoom(){
      this.zoomViewDialog = false;
    },
  }
}
</script>